module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-3-d415e538351bbab4f031406f3bb1dad4.webp";